import React from "react";
import ReactDOM from "react-dom";
import "./Modal.css";

const Modal = ({ isShowing, hide, children, headerText }) =>
    isShowing
        ? ReactDOM.createPortal(
              <>
                  <div className="overlay" />
                  <div
                      className="wrapper"
                      aria-modal
                      aria-hidden
                      tabIndex={-1}
                      role="dialog"
                  >
                      <div className="modal-body">
                          <div className="modal-header">
                              <div>
                                  <div className="header-text">
                                      {headerText}
                                  </div>
                              </div>
                              <div>
                                  <button
                                      type="button"
                                      className="modal-close-button icon-button"
                                      data-dismiss="modal"
                                      aria-label="Close"
                                      onClick={hide}
                                  >
                                      <span
                                          className="material-icons-outlined"
                                          aria-hidden="true"
                                      >
                                          close
                                      </span>
                                  </button>
                              </div>
                          </div>
                          <div className="child-container">{children}</div>
                      </div>
                  </div>
              </>,
              document.body
          )
        : null;

export default Modal;
